import { FunctionalAnalysesImportanceEnum } from '../enums/functional-analyses-importance-enum';

export class FunctionalAnalysisDataPayload {
  importance?: FunctionalAnalysesImportanceEnum;
  discussion: string;
  srcContribution?: number;
  destContribution?: number;
  testedPartyContribution?: boolean;
  otherParticipantContribution?: boolean;
}
